<template>
    <div class="stat-card">
        <div class="title">
            <div class="icon" v-if="icon">
                <md-icon>{{ icon }}</md-icon>
            </div>
            <div class="text">
                {{ title }}
            </div>
        </div>
        <div class="value-wrapper">
            <span class="value">{{ value }}</span>
            <div class="unit" v-if="unit">
                <span>/</span>
                <span>{{ unit }}</span>
            </div>
        </div>
        <div class="description">
            {{ description }}
        </div>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "StatCard",
    props: {
        title: {
            type: String,
            default: "",
        },
        value: {
            type: String | Number,
            default: "",
        },
        unit: {
            type: String,
        },
        icon: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
    },
});
</script>

<style scoped lang="scss">
.stat-card {
    display: flex;
    gap: 5px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 100%;
    padding: 30px 20px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    flex: 1 1 auto;

    .title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 30%;

        .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30%;
            height: 100%;

            md-icon {
                font-size: 40px;
                color: #000;
            }
        }

        .text {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 70%;
            height: 100%;
            font-size: 20px;
            font-weight: 600;
            color: #000;
            text-wrap: nowrap;
        }
    }

    .value-wrapper {
        margin-top: 10px !important;
        display: flex;
        gap: 5px;
        align-items: center;
        margin-top: 5px;

        .value {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 30%;
            font-size: 30px;
            font-weight: 600;
            color: #000;
        }

        .unit {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 30%;
            font-size: 20px;
            font-weight: 600;
            color: #000;
        }
    }

    .description {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 40%;
        font-size: 14px;
        font-weight: 600;
        color: #000;
    }
}
</style>
